/**
 * SplitBar — полоска соотношения Соло/Клиника + легенда. Соло — синий,
 * Клиника — тил (--success). `compact` — укороченная легенда для мобилки.
 */

type SplitBarProps = {solo: number; clinic: number; compact?: boolean};

export const SplitBar = ({solo, clinic, compact = false}: SplitBarProps) => {
  const total = solo + clinic || 1;
  const soloPct = Math.round((solo / total) * 100);
  return (
    <div>
      <div className="flex h-[7px] gap-[5px] overflow-hidden rounded-[4px]">
        <div className="bg-primary" style={{width: `${soloPct}%`}} />
        <div className="bg-success" style={{width: `${100 - soloPct}%`}} />
      </div>
      <div className="mt-2 flex justify-between text-[11.5px] text-muted-foreground">
        <span className="flex items-center gap-[5px]">
          <span className="size-2 rounded-full bg-primary" />
          {compact ? 'Соло' : 'Соло'} <b className="font-mono text-foreground">{solo}</b>
        </span>
        <span className="flex items-center gap-[5px]">
          <span className="size-2 rounded-full bg-success" />
          {compact ? 'Клин.' : 'Клиника'} <b className="font-mono text-foreground">{clinic}</b>
        </span>
      </div>
    </div>
  );
};
